import React from 'react';
import { graphql, Link, navigate } from 'gatsby';

import Button from 'react-bootstrap/Button';

import { Layout } from '../components/layout/layout';
import { Main, MainContent, MainSide } from '../components/content/main';
import Curated from '../components/blogs/curated';
import { Excerpt } from '../components/blogs/excerpt';
import HeadlinesSide from '../components/sidebars/headlines';
import ShowSchedule from '../components/showschedule/showschedule';
import { BlogTagsSide } from '../components/sidebars/blogtags';

export default function Home({ data }) {
	const dtNow = new Date();
	const posts = data.blogs.posts.filter(post => {
		const dtHeadline = new Date(post.frontmatter.date);
		return dtHeadline < dtNow;
	});
	const topPost = posts.find(post => post.frontmatter.interact?.includes('featured=1'));
	return (
		<Layout>
			<React.Fragment>
				<Main>
					<MainContent>
						<TopStory post={topPost} imageStyle={1} />
					</MainContent>
					<MainSide styles={[]}>
						<HeadlinesSide heading='Other Headlines' series='' exclude={[topPost.id]} />
					</MainSide>
				</Main>
				<Main styles={['guided']}>
					<MainContent>
						<h2>Tower of the Hand Guides</h2>
						<p>Every book, chapter by chapter. Every show, episode by episode.</p>
						<div className='flexRow'>
							<div className='sectionMap'>
								<b><Link to='/books/'>A Song of Ice and Fire</Link></b>
								<ol>
									<li><Link to='/books/101/'>A Game of Thrones</Link></li>
									<li><Link to='/books/102/'>A Clash of Kings</Link></li>
									<li><Link to='/books/103/'>A Storm of Swords</Link></li>
									<li><Link to='/books/104/'>A Feast for Crows</Link></li>
									<li><Link to='/books/105/'>A Dance with Dragons</Link></li>
								</ol>
							</div>
							<div className='sectionMap'>
								<b><Link to='/gameofthrones/'>Game of Thrones</Link></b>
								<ol>
									<li><Link to='/gameofthrones/1/'>Season 1 (2011)</Link></li>
									<li><Link to='/gameofthrones/2/'>Season 2 (2012)</Link></li>
									<li><Link to='/gameofthrones/3/'>Season 3 (2013)</Link></li>
									<li><Link to='/gameofthrones/4/'>Season 4 (2014)</Link></li>
									<li><Link to='/gameofthrones/5/'>Season 5 (2015)</Link></li>
									<li><Link to='/gameofthrones/6/'>Season 6 (2016)</Link></li>
									<li><Link to='/gameofthrones/7/'>Season 7 (2017)</Link></li>
									<li><Link to='/gameofthrones/8/'>Season 8 (2019)</Link></li>
								</ol>
							</div>
							<div className='sectionMap'>
								<b><Link to='/houseofthedragon/'>House of the Dragon</Link></b>
								<ShowSchedule showTitle='House of the Dragon' seasonIndex={2} />
							</div>
						</div>
					</MainContent>
				</Main>
				<Main>
					<MainContent>
						<Curated />
						<LatestPosts posts={posts} />
					</MainContent>
					<MainSide styles={['sticky','leading','meta']}>
						<BlogTagsSide />
						<aside>
							<h2>Ice and Fire Links</h2>
							<ol>
								<li><a href='https://www.georgerrmartin.com/'>George R.R. Martin's Website</a></li>
								<li><a href='https://georgerrmartin.com/notablog/'>GRRM's Not a Blog</a></li>
								<li><a href='https://www.westeros.org/'>Westeros.org</a></li>
								<li><a href='https://watchersonthewall.com/'>Watchers on the Wall</a></li>
								<li><a href='https://winteriscoming.net/'>Winter Is Coming</a></li>
								<li><a href='http://www.podcastoficeandfire.com/'>A Podcast of Ice and Fire</a></li>
								<li><a href='https://www.historyofwesteros.com/'>History of Westeros</a></li>
								<li><a href='https://racefortheironthrone.wordpress.com/'>Race for the Iron Throne</a></li>
								<li><a href='https://visionsoiaf.wordpress.com/'>VisionSOIAF</a></li>
							</ol>
						</aside>
					</MainSide>
				</Main>
			</React.Fragment>
		</Layout>
	);
};

const TopStory = (props) => {
	const { post, imageStyle } = props;
	return (
		<article className='record'>
			{imageStyle === 1 && <img src={post.frontmatter.heroimage} alt={post.frontmatter.title} /> }
			<h3>
				<Link to={post.fields.slug}>{post.frontmatter.title}</Link>
			</h3>
			<div>{post.frontmatter.description}</div>
		</article>
	);
};

const LatestPosts = (props) => {
	const { posts } = props;
	return (
		<React.Fragment>
			<h2>Latest Posts</h2>
			{posts.map(post => <Excerpt key={post.id} post={post} />)}
			<div style={{ marginTop: '3em', textAlign: 'right' }}>
				<Button className='standard'
					onClick={() => navigate('/blog/p/2/')}
				>
					Next &gt;
				</Button>
			</div>
		</React.Fragment>
	);
};

export const indexPageQuery = graphql`
	query IndexPageQuery {
	  blogs: allMarkdownRemark(
		filter: {fields: {source: {eq: "content"}}, frontmatter: {type: {eq: "blog"}}}
		sort: {frontmatter: {date: DESC}}
		limit: 10
		skip: 0
	  ) {
		posts: nodes {
		  fields {
			slug
		  }
		  frontmatter {
			date
			title
			author
			description
			tags
			interact
			heroimage
		  }
		  timeToRead
		  html
		  excerpt(pruneLength: 200, format: HTML)
		  id
		}
	  }
	}
`